export default "__VITE_ASSET__Bw85zVUe__"